<template>
  <layout :title="`Добавление новости`">
    <news-form></news-form>
  </layout>
</template>

<script>
import Layout from '~/Layouts/Layout'
import NewsForm from '~/Components/News/NewsForm'

export default {
  components: {
    Layout,
    NewsForm
  }
}
</script>
